
module.exports = [
  {  //菜单管理
    path:"/ms/menu",
    breadcrumb:[
      {name: "菜单管理",path:"/ms/menu"},
    ]
  },
  {  //菜单权限管理
    path:"/ms/loginMenuManagement",
    breadcrumb:[
      {name: "菜单权限管理",path:"/ms/loginMenuManagement"},
    ]
  },
];



// WEBPACK FOOTER //
// ./src/util/breadcrumb.js